<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.7922 3.47323C13.6769 2.41659 11.8387 3.20728 11.8387 4.74365V7.51436C8.03108 7.62734 5.2306 8.4208 3.40108 10.4007C1.51406 12.4428 0.882639 15.5141 0.840883 19.5621C0.829529 20.6611 2.36234 21.1653 2.92005 20.0772C3.58051 18.7889 4.10834 18.0191 5.24753 17.4772C6.42293 16.918 8.3362 16.5628 11.8387 16.5076V19.2564C11.8387 20.7927 13.6769 21.5835 14.7923 20.5267L22.4516 13.2704C23.1803 12.5802 23.1803 11.4198 22.4516 10.7295L14.7922 3.47323ZM20.8846 12L13.8387 5.32488V8C13.8387 8.51685 13.5803 8.96096 13.1952 9.22978C12.9525 9.39918 12.6596 9.49898 12.3494 9.50353C8.44797 9.56081 6.20168 10.3169 4.86997 11.758C3.90618 12.801 3.30532 14.3244 3.02541 16.5503C3.40613 16.2222 3.85176 15.9264 4.38838 15.6711C6.04434 14.8834 8.46792 14.5303 12.3263 14.5019C13.1498 14.4958 13.8387 15.1608 13.8387 16V18.6751L20.8846 12Z"
    />
  </svg>
</template>
